import { render, staticRenderFns } from "./VariableSetView.vue?vue&type=template&id=5b6f978f"
import script from "./VariableSetView.vue?vue&type=script&lang=js"
export * from "./VariableSetView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports